var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"section-card",attrs:{"flat":"","tile":"","outlined":""}},[(_vm.title)?_c('v-card-title',[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('v-container',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }